import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopComments728x90Gak from './gak/DesktopComments728x90';
import DesktopComments728x90Hashtag from './hashtag/DesktopComments728x90';
const DesktopComments728x90 = ({ safety = 'off', safetyState })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(DesktopComments728x90Hashtag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopComments728x90Gak, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopComments728x90.displayName = 'DesktopComments728x90';
export default DesktopComments728x90;
